import React from 'react';
import { Provider } from 'react-redux';
import {
  ChakraProvider,
  extendTheme
} from '@chakra-ui/react';

import AppRouter from './routers/AppRouter';
import storeConfig from './store/storeConfig';
import { initializeAuth } from './actions/authActions';
// import './styles/styles.scss';

export const store = storeConfig();

store.dispatch(initializeAuth());

function App() {
  const theme = extendTheme({
    styles: {
      global: {
        // styles for the `body`
        body: {
          margin: 0,
          padding: 0,
          fontSize:"14px"
        }
      }
    }
  })
  return (
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <AppRouter />
      </Provider>  
    </ChakraProvider>
  );
}

export default App;
